import React, { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import DetailWrapper from '../../../sharedcomponents/4layouts/DetailWrapper'
import useDetailEditMode from '../../../sharedcomponents/4layouts/useDetailEditMode'
import LeftCard from '../../../sharedcomponents/5templates/detailCards/leftCard'
import ListBucketCard from '../../../sharedcomponents/5templates/detailCards/listBucketCard'
import useSkillset from './useSkillset'
const SkillsetDetail = ({ createMode }) => {
  const { skillsetId, type } = useParams()
  const formikFunctionBucket = {}

  const { detailEditMode, setDetailEditMode } = useDetailEditMode(createMode)

  const {
    useGetOneSkillsetQuery,
    fetchAuxiliaryRecords,
    bulkUpdateSkillsetsCallBack,
    upsertSkillsetCallback,
    finalAuxiliaryRecords,
    makeInMemorySkillsetRecord,
    removeSkillset,
    suspendSkillset,
    loading: updateSkillSetLoading
  } = useSkillset()

  const {
    data: { data: rawSkillsetRecord } = {
      data: {}
    },
    refetch,
    isLoading,
    isSuccess
  } = useGetOneSkillsetQuery(
    {
      include: ['counts'],
      id: skillsetId
    },
    { skip: createMode, refetchOnMountOrArgChange: true }
  )

  const loading = useMemo(() => updateSkillSetLoading || isLoading, [updateSkillSetLoading, isLoading])

  const primarySkillsetRecord = createMode
    ? makeInMemorySkillsetRecord(type)
    : JSON.parse(JSON.stringify(rawSkillsetRecord))
  primarySkillsetRecord.refetch = refetch

  return (
    <DetailWrapper
      entityDisplayName={'Skillset'}
      detailEditMode={detailEditMode}
      setDetailEditMode={setDetailEditMode}
      primaryDetailRecord={primarySkillsetRecord}
      isLoading={!createMode && (loading || !isSuccess)}
      secondaryDataLoaderCallBack={fetchAuxiliaryRecords}
      upsertDetailCallback={upsertSkillsetCallback}
      bulkUpdateCallBack={bulkUpdateSkillsetsCallBack}
      finalAuxiliaryRecords={finalAuxiliaryRecords}
    >
      {({ formikProps, activationChangeCallback, deleteEntityCallback }) => {
        formikFunctionBucket.setFieldValue = formikProps.setFieldValue
        return (
          <>
            <div style={{ float: 'left', width: '34%' }}>
              <LeftCard
                entityDisplayName={'Skillset'}
                formikProps={formikProps}
                editMode={detailEditMode}
                deleteEntityCallback={deleteEntityCallback(removeSkillset)}
                activationChangeCallback={activationChangeCallback(suspendSkillset)}
                arrayOfBucketConfig={finalAuxiliaryRecords?.primero}
              />
            </div>
            <div style={{ float: 'right', width: '66%' }}>
              <ListBucketCard
                formikProps={formikProps}
                editMode={detailEditMode}
                arrayOfBucketConfig={finalAuxiliaryRecords?.segundo}
              />
            </div>
          </>
        )
      }}
    </DetailWrapper>
  )
}
export default React.memo(SkillsetDetail)
